import { NodoEstructuraJerarquica } from './nodo-estructura-jerarquica.model';
import { EstructuraJerarquica } from './estructura-jerarquica.model';
import { ReglaBase} from './regla-base.model';
import { Evaluacion} from './evaluacion.model';

export class Cumplimiento
{
    id: number;
    reglaBase: ReglaBase;
    estructuraJerarquica: EstructuraJerarquica;
    nodoEstructuraJerarquica: NodoEstructuraJerarquica;
    evaluaciones: Evaluacion[];
    fechaInicio: Date;
    fechaFin: Date;
    /**
     * Constructor
     *
     * @param cumplimiento
     */
    constructor(evaluacion)
    {
        {
            this.id = evaluacion.id || null;
            this.estructuraJerarquica = evaluacion.estructuraJerarquica || null;
            this.nodoEstructuraJerarquica= evaluacion.nodoEstructuraJerarquica || null;
            this.evaluaciones = evaluacion.evaluaciones || [];
            this.reglaBase = evaluacion.reglaBase || null;
            this.fechaInicio = evaluacion.fechaInicio || null;
            this.fechaFin = evaluacion.fechaFin || null;

        }
    }
}
